<template>
    <div class="a-form-inputs c-split-screen p-day-one">
        <div v-show="theCurrentWidth < 1024">
            <header-section
                set-position="relative"
                set-width="100">
            </header-section>
        </div>
        <div class="c-split-screen__container">
            <div class="c-split-screen__column-one">
                <h1>Day One Reserve Tool</h1>

                <p>
                    Our unique reserving function allows you to perform accurate day one assessments of reserves based on your claims history.</p>
                <br/>

                <p>Enter your claim type to start the reserving function</p><br/>

                <control for="" label="Enter Claim Type" :icon-space="false">
                    <select name="" id="" v-model="selectedClaimType" @change="route">
                        <option value="" hidden>Please Select...</option>
                        <option value="fatal">Fatal Accident Claim</option>
                        <option value="lost">Lost Years Claim</option>
                    </select>
                </control>
                <router-view class="u-margin-bottom-20" name="form"></router-view>
            </div>
            <div class="c-split-screen__column-two">
                <router-view class="u-margin-bottom-20" name="results"></router-view>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">

    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import FormValidator from 'components/form/validator/mixin';
    import DateInput from 'components/form/control/DateInput.vue';
    import HeaderSection from 'components/Header.vue';
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'day-one-simple',
        components: {Control, ControlError, FormValidator, DateInput, HeaderSection},
        data: function () {
            let currentRoute = this.$route.path;
            let selectedClaimType = '';
            if (currentRoute === '/reserving/day-one-assessment/fatal') {
                selectedClaimType = 'fatal';
            }
            if (currentRoute === '/reserving/day-one-assessment/lost') {
                selectedClaimType = 'lost';
            }
            return {
                selectedClaimType
            }
        },
        computed: {
            ...mapGetters('windowWidth', ['theCurrentWidth'])
        },
        methods: {
            route() {
                if (!this.selectedClaimType) {
                    return;
                }
                this.$router.push({
                    name: 'reserving::day-one-assessment::' + this.selectedClaimType
                });
            },
            ...mapActions('windowWidth', ['updateWidth']),
        }
    }
</script>

<style lang="scss">

    @import '../../../assets/sass/base/colours.scss';
    @import '../../../assets/sass/base/sizing.scss';
    @import '../../../assets/sass/base/fonts.scss';
    @import '../../../assets/sass/view/component/split-screen.scss';

</style>


// WEBPACK FOOTER //
// DayOneSimple.vue?9b92ad58